<template>
  <v-card>
    <v-toolbar color="white" elevation="4" flat prominent>
      <v-text-field
        class="mx-4"
        flat
        hide-details
        label="Search"
        solo-inverted
      ></v-text-field>
      <v-spacer> </v-spacer>
      <v-btn style="width: 25%" large outlined @click="this.openDialog">
        <v-icon class="mr-2"> mdi-bullhorn-outline</v-icon>

        <label class="description"></label> Make Announcement</v-btn
      >
      <dialog-container>
        <div slot="content">
          <add-announcement-form />
        </div>
      </dialog-container>
    </v-toolbar>

    <!-- Announcement  -->

    <v-row>
      <v-col
        cols="6"
        sm="6"
        md="6"
        v-for="(item, index) in announcements"
        :key="index"
      >
        <announcement-list
          :id="item.id"
          :date="item.date"
          :time="item.time"
          :type="item.type"
          :source="item.source"
          :body="item.body"
          :reference="item.reference"
        />
      </v-col>
    </v-row>
  </v-card>
</template> 

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import moment from "moment";
import { eventBus } from "@/main.js";
import AnnouncementList from "../components/AnnouncementList";
import DialogContainer from "../shared/components/dialogContainer";
import AddAnnouncementForm from "../forms/AddAnnouncementForm";
export default {
  async created() {
    await this.fetchAllAnnouncement();
  },
  components: {
    AnnouncementList,
    AddAnnouncementForm,
    DialogContainer,
  },
  computed: {
    ...mapFields("announcement", ["allAnnouncements"]),
  },
  data() {
    return {
      announcements: [],
    };
  },
  methods: {
    ...mapActions("announcement", ["fetchAllAnnouncement"]),
    ...mapActions("shared", ["showEditForm"]),
    openDialog() {
      // set the form as New form
      this.showEditForm({
        payload: {
          isEdit: false,
        },
      });
      eventBus.$emit("formChangeEvent", true);
      eventBus.$emit("dialogToggle", true);
    },
  },
  watch: {
    allAnnouncements: {
      immidate: true,
      handler(value) {
        
        value.map((announcement) => {
          this.announcements.push({
            id: announcement.id,
            title: announcement.content.message_en,
            body: announcement.content.message_en,
            source: announcement.content.source,
            date: announcement.content.date,
            time: "",
            type: announcement.content.type,
            reference: "https://covidET.com", // static until it is implemented
          });
        });
      },
    },
  },
};
</script>

<style scoped>
.description {
  font-family: "Poppins";
  font-size: 20px;
}
</style>